var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInvitationsUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.4,79.415a10.548,10.548,0,1,1,10.55-10.547A10.56,10.56,0,0,1,250.4,79.415Zm0-19.106a8.558,8.558,0,1,0,8.56,8.558A8.568,8.568,0,0,0,250.4,60.309Z",
    transform: "translate(-232.531 -58.319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.131,92.882a.994.994,0,0,1-.989-.9,16.023,16.023,0,0,0-31.828-.515.982.982,0,0,1-1.116.856.993.993,0,0,1-.857-1.115,18.013,18.013,0,0,1,35.78.578,1,1,0,0,1-.893,1.088C269.2,92.88,269.164,92.882,269.131,92.882Z",
    transform: "translate(-234.334 -52.682)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvitationsUser);
export default __webpack_public_path__ + "static/media/icon_invitations_user.79762ecda7186dba3b57550f3fd7fca7.svg";
export { ForwardRef as ReactComponent };